import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import SSRSafeElement from 'commons/SSRSafeElement';
import BaseField from './BaseField';
const SmartyStreetsFloatingField = t0 => {
  const $ = _c(36);
  let error;
  let handleBlur;
  let handleChange;
  let isTouched;
  let props;
  let setFieldValue;
  let showError;
  let t1;
  let t2;
  let t3;
  let t4;
  let updateShipping;
  let value;
  if ($[0] !== t0) {
    ({
      id: t1,
      name: t2,
      value,
      error,
      showError,
      isTouched,
      handleBlur,
      handleChange,
      setFieldValue,
      updateShipping,
      isRequired: t3,
      refField: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = handleBlur;
    $[3] = handleChange;
    $[4] = isTouched;
    $[5] = props;
    $[6] = setFieldValue;
    $[7] = showError;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = updateShipping;
    $[13] = value;
  } else {
    error = $[1];
    handleBlur = $[2];
    handleChange = $[3];
    isTouched = $[4];
    props = $[5];
    setFieldValue = $[6];
    showError = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    updateShipping = $[12];
    value = $[13];
  }
  const id = t1 === undefined ? "address" : t1;
  const name = t2 === undefined ? "address" : t2;
  const isRequired = t3 === undefined ? true : t3;
  const refField = t4 === undefined ? null : t4;
  let t5;
  if ($[14] !== error || $[15] !== updateShipping) {
    t5 = debounce(updatedValue => {
      if (!error && updatedValue) {
        updateShipping?.({
          address: updatedValue
        });
      }
    }, 400);
    $[14] = error;
    $[15] = updateShipping;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const updateShippingDebounced = t5;
  let t6;
  if ($[17] !== handleChange || $[18] !== updateShippingDebounced) {
    t6 = evt => {
      handleChange(evt);
      updateShippingDebounced(evt.target.value);
    };
    $[17] = handleChange;
    $[18] = updateShippingDebounced;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const changeHandler = t6;
  let t7;
  if ($[20] !== changeHandler || $[21] !== error || $[22] !== handleBlur || $[23] !== isRequired || $[24] !== isTouched || $[25] !== props || $[26] !== refField || $[27] !== setFieldValue || $[28] !== showError || $[29] !== updateShipping || $[30] !== value) {
    t7 = t8 => {
      const {
        field
      } = t8;
      return <BaseField type="text" field={field} value={value} onBlur={evt_0 => {
        handleBlur(evt_0);
        if (!error) {
          updateShipping?.();
        }
      }} onChange={changeHandler} setFieldValue={setFieldValue} placeholder="Street address *" autoComplete="address-line1" errorstate={isTouched && error} data-xc="shipping-address-field" required={isRequired ? "" : undefined} aria-required={isRequired ? "" : undefined} refField={refField} errorMessage={showError && isTouched && error} {...props} />;
    };
    $[20] = changeHandler;
    $[21] = error;
    $[22] = handleBlur;
    $[23] = isRequired;
    $[24] = isTouched;
    $[25] = props;
    $[26] = refField;
    $[27] = setFieldValue;
    $[28] = showError;
    $[29] = updateShipping;
    $[30] = value;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== id || $[33] !== name || $[34] !== t7) {
    t8 = <Field id={id} name={name} render={t7} />;
    $[32] = id;
    $[33] = name;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  return t8;
};
SmartyStreetsFloatingField.propTypes = {
  addressFieldName: PropTypes.string,
  stateFieldName: PropTypes.string,
  cityFieldName: PropTypes.string,
  zipCodeFieldName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  showError: PropTypes.bool,
  isTouched: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  isRequired: PropTypes.bool,
  updateShipping: PropTypes.func,
  refField: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement)
  })
};
export default SmartyStreetsFloatingField;